import CustomCheckBox from "../../../components/form/CustomCheckBox";
import {PLATFORMS} from "../../../constants/commons";
import FormLabel from "../../../components/form/FormLabel";

const PlatformSelector = ({platforms = [], setPlatform, oneValueMandatory = true, disabled = false}) => {

  const updatePlatform = (checked, platform) => {
    if (checked || platforms.length > 1 || !oneValueMandatory)
      setPlatform(checked ? [...platforms, platform] : platforms.filter((p) => p.value !== platform.value));
  };
  return (
    <>
      <FormLabel label="Select Platform"/>
      <div className="flex space-x-4 md:space-x-6 text-sm mb-4">
        {Object.values(PLATFORMS).map((p) =>
          <CustomCheckBox key={`${p.label}-platform`} label={p.label}
                          disabled={disabled}
                          onChange={(e) => updatePlatform(e.target.checked, p)}
                          checked={platforms.some((pl) => pl.value === p.value)}/>)}

      </div>
    </>
  );
};

export default PlatformSelector;